module.exports = __webpack_public_path__ + "img/germany-breast-cancer-female.71ea29b5.png";